<div class="brand-header">
  <ng-container *ngIf="data.logo">
    <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
  </ng-container>
  <div class="brand-details">
    <h1>{{ data.companyName | camelcase}}</h1>
    <ng-container *ngIf="data.url">
      <a class="data-url" (click)="sanitizeUrl(data.url); $event.preventDefault();"
      rel="noopener noreferrer">
        {{ data.url }}

      </a>
    </ng-container>
  </div>
</div>
<div class="parent-container">
  <div class="filter">
    <app-brand-product-filter [filterColumns]="['Products', 'Region']" [data]="originalData" [catalogData]="catalogData" (productIdsListEmit)="getFilteredProductListIds($event)"  [brandProfileProducts]="brandProfileProducts" (filteredData)="onFilteredData($event)" [isCatalogSection]="isCatalogSection" [heading]="'Explore Catalogs'" ></app-brand-product-filter>
  </div>

  <div class="product-list">
    <div *ngIf="products.length===0"  class="no-results">
      <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
      <div class="no-records-found"> No Catalogs Found </div>
    </div>
    <div class="card catalogCard" *ngFor="let catalog of paginatedItems">
      <div *ngIf="catalog.type === 'image'">
        <img [src]="catalog.catalog" alt="catalog" class="catalog-image"/>
      </div>
      <div *ngIf="catalog.type === 'pdf'">
        <div class="iframe-container">
          <iframe [src]="catalog.catalog | safe" class="main-iframe"></iframe>
        </div>
      </div>
      <div class="card-actions">
        <h3>{{ getFormattedName(catalog?.catalog?.split('/')?.pop()) | camelcase}} </h3>
        <p></p>
      </div>
      <div class="buttons">
        <div class="buttons">
          <button class="view-button" (click)="viewCatalog(catalog)"><img src="assets/images/white-eye.svg" alt="view"/>View</button>
          <button class="download-button" (click)="downloadCatalog(catalog)"><img src="assets/images/download.svg" alt="Download"/>Download</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="pagination-container"> 
  <span class="catalog-pagination" >
    <app-pagination [itemsPerPage]="itemsPerPage" [data]="products" (pageChanged)="onPageChanged($event)"></app-pagination>
    <p class="catalogTotalEntries">Total Entries: {{ products.length }} </p>
  </span>
</div>
